import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";

import Error from "../../components/Buy/Error";
import { newUUID, getParsedURL, resetError } from "../../actions/buy";

const Buy = () => {
  const dispatch = useDispatch();
  let [searchParams, setSearchParams] = useSearchParams();

  const currencyCode = searchParams.get("code");
  const walletAddress = searchParams.get("address");
  const appInstallDate = searchParams.get("idate");
  const user_id = searchParams.get("uid");

  const { errors, moonpayURL } = useSelector((state) => state.buy);
  const { messages } = errors;

  useEffect(() => {
    dispatch(newUUID("order_id"));

    return () => {
      dispatch(resetError());
    };
  }, []);

  useEffect(() => {
    if (walletAddress === undefined) return;
    const data = {
      currencyCode,
      walletAddress,
      appInstallDate,
      user_id,
    };
    dispatch(getParsedURL(data));
  }, [currencyCode, walletAddress, appInstallDate, user_id]);

  const Errors = messages.map((err) => {
    return (
      <Error messages={err} key={err} onClick={() => dispatch(resetError())} />
    );
  });

  React.useEffect(() => {
    if (moonpayURL && messages.length == 0) {
      window.location.replace(moonpayURL);
    }
  }, [moonpayURL]);

  return <div>{Errors}</div>;
};

export default Buy;
